import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { KiMarkComponent } from '../ki-mark/ki-mark.component';

export type KiMarkerArt = 'befund' | 'geaendert';

const TEXTE: Record<KiMarkerArt, { text: string; titel: string }> = {
  befund: { text: 'ki.qualitaet.marker.befund', titel: 'ki.qualitaet.marker.befundTitel' },
  geaendert: { text: 'ki.qualitaet.marker.geaendert', titel: 'ki.qualitaet.marker.geaendertTitel' },
};

@Component({
  selector: 'app-ki-marker',
  imports: [KiMarkComponent, TranslatePipe],
  templateUrl: './ki-marker.component.html',
  styleUrl: './ki-marker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KiMarkerComponent {
  readonly art = input.required<KiMarkerArt>();

  protected readonly texte = computed(() => TEXTE[this.art()]);
}
